module.exports = __webpack_public_path__ + "media/images/static/top/urban/line_top-4c7c4705da5ef1079ef528ac7d4c699b.png";